module.exports = __webpack_public_path__ + "img/OK_logo.f5cabf4d.svg";